var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.1096,
    height: 24,
    rx: 4,
    fill: "#FF510D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0547 10.5C18.5859 10.5 19.0547 10.9688 19.0547 11.5V12.5C19.0547 13.0625 18.5859 13.5 18.0547 13.5H6.05469C5.49219 13.5 5.05469 13.0625 5.05469 12.5V11.5C5.05469 10.9688 5.49219 10.5 6.05469 10.5H18.0547Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minus-icon.9a93c14fdf018582aafdb6e0b283af9e.svg";
export { ForwardRef as ReactComponent };